import useAnimatedMount from "@/hooks/utils/useAnimatedMount";
import { cn } from "@/lib/utils";
import { ReactNode } from "react";

interface AnimatedMountProps {
    children: ReactNode;
    shouldShow: boolean;
    duration?: number;
    className?: string;
    onUnmount?: () => void;
}

/**
 * Wrapper component to handle animated mount/unmount
 * @param children - Content to animate
 * @param shouldShow - Condition to determine if the content should be visible
 * @param duration - Animation duration in ms (default: 500)
 * @param className - Additional CSS classes
 * @param onUnmount - Callback called on unmount
 */
const AnimatedMount = ({
    children,
    shouldShow,
    duration = 500,
    className,
    onUnmount,
}: AnimatedMountProps) => {
    const { isMounted, isVisible } = useAnimatedMount(shouldShow, {
        duration,
        onUnmount,
    });

    if (!isMounted) {
        return null;
    }

    return (
        <div
            className={cn(
                "transition-opacity duration-500",
                isVisible ? "opacity-100" : "opacity-0",
                className,
            )}
        >
            {children}
        </div>
    );
};

export default AnimatedMount;
